import React from 'react';

import { useSearchParams } from '@/hooks/useSearchParams';

export const useSiteSearchState = () => {
    const searchParams = useSearchParams();

    const [state, setState] = React.useState('default');

    React.useEffect(() => {
        setState(!searchParams.has('q') ? 'default' : 'results');
    }, [searchParams]);

    return state;
};
